module.exports = __webpack_public_path__ + "img/deface.1c89c957.png";